// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10uGD","col":"styles_col__1vivv"};